import {
  Container,
  Title,
  Text,
  Stack,
  Badge,
  Table,
  Loader,
  Center,
  Alert,
} from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import { useTasksAdmin } from "../../../hooks/admin/useTasks";

export default function TasksAdminPage() {
  const { data: tasks = [], isLoading } = useTasksAdmin();

  if (isLoading) {
    return (
      <Center py="xl">
        <Loader />
      </Center>
    );
  }

  return (
    <Container size="lg" py="md">
      <Stack gap="lg">
        <div>
          <Title order={2}>Tasks</Title>
          <Text c="dimmed" size="sm">
            Task definitions that determine which workflows users can access.
          </Text>
        </div>

        <Alert icon={<IconInfoCircle size={16} />} color="blue" variant="light">
          Tasks are core system definitions managed by developers. Contact a
          developer if changes are needed.
        </Alert>

        <Table striped highlightOnHover withTableBorder>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Name</Table.Th>
              <Table.Th>Slug</Table.Th>
              <Table.Th>Order</Table.Th>
              <Table.Th>Status</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {tasks.map((task) => (
              <Table.Tr key={task.id}>
                <Table.Td fw={500}>{task.name}</Table.Td>
                <Table.Td>
                  <Text size="sm" c="dimmed" ff="monospace">
                    {task.slug}
                  </Text>
                </Table.Td>
                <Table.Td>{task.displayOrder}</Table.Td>
                <Table.Td>
                  <Badge
                    color={task.isActive ? "green" : "gray"}
                    variant="light"
                    size="sm"
                  >
                    {task.isActive ? "Active" : "Inactive"}
                  </Badge>
                </Table.Td>
              </Table.Tr>
            ))}
            {tasks.length === 0 && (
              <Table.Tr>
                <Table.Td colSpan={4}>
                  <Text c="dimmed" size="sm" ta="center" py="md">
                    No tasks found.
                  </Text>
                </Table.Td>
              </Table.Tr>
            )}
          </Table.Tbody>
        </Table>
      </Stack>
    </Container>
  );
}
